import { DataGrid, GridColDef } from '@mui/x-data-grid'
import { DateTime } from 'luxon';
import { useEffect, useState } from 'react';
import { useReadHostServicePricesByMonitorIdQuery } from '../../../../../../services/hostService';

interface HostServiceDetailPriceListTableProps {
    marketSpyId?: number,
    hostServiceId?: number
}

const columns: GridColDef[] = [
    {
        field: 'period',
        headerName: 'Period',
        width: 178,
        valueGetter: (value, row, column, apiRef) => {
            const dateTimeCheckIn = DateTime.fromISO(row.checkin).toFormat('M/dd/yyyy');
            const dateTimeCheckOut = DateTime.fromISO(row.checkout).toFormat('M/dd/yyyy');

            return `${dateTimeCheckIn} - ${dateTimeCheckOut}`
        }
    },
    {
        field: 'priceTotal',
        minWidth: 84,
        flex: 0,
        headerName: 'Price Total',
        valueGetter: (value, row, column, apiRef) => {
            if (row.priceTotal === undefined || row.priceTotal === null || row.priceTotal === 0) {
                return 'N/A';
            }

            return `$${(row.priceTotal)}`;
        }
    },
    {
        field: 'originalPrice',
        minWidth: 120,
        flex: 1,
        headerName: 'Original Price',
        valueGetter: (value, row, column, apiRef) => {
            if (row.originalPrice === undefined || row.originalPrice === null || row.originalPrice === 0) {
                return 'N/A';
            }

            return `$${(row.originalPrice)}`;
        }
    },
    {
        field: 'discountedPrice',
        minWidth: 140,
        flex: 1,
        headerName: 'Discounted Price',
        valueGetter: (value, row, column, apiRef) => {
            if (row.discountedPrice === undefined || row.discountedPrice === null) {
                return '';
            }

            return `$${(row.discountedPrice)}`;
        }
    },
];


export const HostServiceDetailPriceListTable = (props: HostServiceDetailPriceListTableProps): JSX.Element => {
    const {
        hostServiceId,
        marketSpyId
    } = props

    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 5,
    })
    const [readHostServicePricesByMonitorIdQueryParams, setReadHostServicePricesByMonitorIdQueryParams] = useState<any>(undefined)
    const [readHostServicePricesByMonitorIdQueryOptions, setReadHostServicePricesByMonitorIdQueryOptions] = useState<any>({
        skip: true,
    })

    const {
        data: readHostServicePricesByMonitorIdData,
        isLoading: readPropertySpyListIsLoading,
        isFetching: readPropertySpyListIsFetching
    } = useReadHostServicePricesByMonitorIdQuery(readHostServicePricesByMonitorIdQueryParams, readHostServicePricesByMonitorIdQueryOptions);

    useEffect(() => {
        setReadHostServicePricesByMonitorIdQueryOptions((prev: any) => {
            return {
                skip: hostServiceId === undefined || marketSpyId === undefined
            }
        })

        setReadHostServicePricesByMonitorIdQueryParams((prev: any) => {
            return {
                hostServiceId: hostServiceId,
                monitorId: marketSpyId,
                pagination: paginationModel
            }
        })
    }, [
        marketSpyId,
        hostServiceId,
        paginationModel
    ])

    return (
        <>
            <DataGrid
                disableColumnFilter={true}
                disableColumnMenu={true}
                disableColumnSorting={true}
                rows={readHostServicePricesByMonitorIdData?.list}
                rowCount={readHostServicePricesByMonitorIdData?.count}
                columns={columns}
                initialState={{
                    pagination: {
                        paginationModel: {
                            pageSize: 5,
                        },
                    },
                }}
                sx={{
                    maxHeight: 400,
                    '& .MuiDataGrid-columnHeaderTitle': {
                        fontSize: {
                            xs: '14px',
                            sm: '16px',
                            md: '18px',
                        },
                        fontWeight: '600'
                    },
                    '& .MuiDataGrid-cellContent': {
                        fontSize: {
                            xs: '14px',
                            sm: '16px',
                            md: '18px',
                        }
                    },
                }}
                disableRowSelectionOnClick
                paginationModel={paginationModel}
                paginationMode="server"
                pageSizeOptions={[5]}
                onPaginationModelChange={setPaginationModel}
            />
        </>
    )
}